import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Loof-tool的 Firebase 配置
const firebaseConfig = {
    apiKey: "AIzaSyB3pmj685acDdXVwaBQ4I77zRz-E22hT7c",
    authDomain: "loof-tool.firebaseapp.com",
    projectId: "loof-tool",
    storageBucket: "loof-tool.firebasestorage.app",
    messagingSenderId: "856462850157",
    appId: "1:856462850157:web:be2f250dc4ab4b974ba764",
    measurementId: "G-EQJY6BFSMR"
  };

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
